import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription, interval } from 'rxjs';
import { ScheduleService } from 'src/app/core';
import { DateOfWeekModel, QueryParamsModel, SettingModel } from 'src/app/shared';
import { ILocationModel } from 'src/app/shared/models/location.model';
import { EScheduleStatus, ScheduleByWeekModel, ScheduleModel } from 'src/app/shared/models/schedule.model';

@Component({
  selector: 'app-display-screen',
  templateUrl: './display-screen.component.html',
  styleUrls: ['./display-screen.component.scss']
})
export class DisplayScreenComponent implements OnInit, OnDestroy {

  scheduleArr: ScheduleModel[] = [];  
  schedules: ScheduleByWeekModel[] = [];    
  today = new Date();
  dateString = `LỊCH HỌP NGÀY ${this.today.getDate()} THÁNG ${this.today.getMonth() + 1} NĂM ${this.today.getFullYear()}`

  private refreshSubscription: Subscription;
  // Subscriptions
  private subscriptions: Subscription[] = [];  
  
  constructor(private scheduleService: ScheduleService, private changeDetectorRef: ChangeDetectorRef) { }

  ngOnInit(): void {    
    this.loadSchedule();
    this.startRefreshInterval();
  }

  ngOnDestroy(): void {
    this.stopRefreshInterval();
  }

  loadSchedule(): void {
    this.today = new Date();
    this.dateString = `LỊCH HỌP NGÀY ${this.today.getDate()} THÁNG ${this.today.getMonth() + 1} NĂM ${this.today.getFullYear()}`
    let today = new Date();

    const filter = {      
      host: 0,
      locationId: -1,
      startDate: `${today.getMonth() + 1
         }/${today.getDate()}/${today.getFullYear()}`,
      endDate: `${today.getMonth() + 1
        }/${today.getDate()}/${today.getFullYear()}`,
      selectAllWeek: false,
      active: 1,
      status: -1,
    };
    const queryParams = new QueryParamsModel(filter);
    const loadSub = this.scheduleService
      .getAllByWeekForFE(queryParams)
      .subscribe((response) => {
        if (response.isSuccess) {
          this.schedules = response.result;          
          this.convertToScheduleList();
          this.changeDetectorRef.detectChanges();
        }
      });

    // this.subscriptions.push(loadSub);
  }

  convertToScheduleList(){
    this.scheduleArr = [];
    this.schedules.forEach(day => {
      day.morning.forEach(morSche => {
        this.scheduleArr.push(morSche)
      });
      day.afternoon.forEach(afSche => {
        this.scheduleArr.push(afSche)
      });
      day.evening.forEach(eveSche => {
        this.scheduleArr.push(eveSche)
      });
    })
    console.log(this.scheduleArr);
    this.scheduleArr = this.scheduleArr.filter(x => x.scheduleStatus == EScheduleStatus.Release);
  }

  startRefreshInterval(): void {
    this.refreshSubscription = interval(180000)
      .subscribe(() => {
        this.loadSchedule();
      });
  }

  stopRefreshInterval(): void {
    if (this.refreshSubscription) {
      this.refreshSubscription.unsubscribe();
    }
  }

}
